module.exports = __webpack_public_path__ + "images/emoji/sheep.dcd5a9fdeaa6a4d679f9.png";